import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faMicrophoneSlash, faTimes } from '@fortawesome/free-solid-svg-icons';
import '../../styles/Concerns.css';

const Mentor = () => {

  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);

  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { mentorId } = useParams();
  const mode = mentorId === undefined ? "add" : "update";
  const [mentor, setMentor] = useState(null);
  const [error, setError] = useState(null);
  const [countFormErrors, setCountFormErrors] = useState(0);
  
  const [formData, setFormData] = useState({
    userId: userId,
    userName: authState.user.name,
    userEmail: authState.user.email,
    userCode: authState.user.think5whyscode,
    mentorCode: '',
    mentorName: '',
    mentorType: '',
    remarks: "",
    dateCreated: new Date(),
    isActive: true,
    isDeleted: false,
    createdBy: userId,
  });

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/mentors/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token },
        data: {mentorId: mentorId} 
      };
        // console.log("getforupdate for update",config);

      fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log("response for update",data);
        setMentor(data.mentor);
        // console.log("response for data.usermentor.userMentorID",data.usermentor.userMentorID);

        setFormData({
          userId: data.mentor.userId,
          userName: data.mentor.userName,
          userCode: data.mentor.userCode,
          userEmail: data.mentor.userEmail,
          mentorCode: data.mentor.mentorCode,
          mentorName: data.mentor.mentorName,
          mentorType: data.mentor.mentorType,
          remarks: data.mentor.remarks,
          dateCreated: data.mentor.dateCreated,
          isActive: data.mentor.isActive,
          isDeleted: data.mentor.isDeleted,
          createdBy: data.mentor.createdBy,
        });
      })
      .catch((error) => {
        console.error("Error fetching Mentor data:", error);
        setError("Error fetching Mentor data");
      });
    }
  }, [mode, authState, mentorId, fetchData, setMentor]);


  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const handleReset = e => {
    e.preventDefault();
    setFormData({
      userId: mentor.userId,
      userName: mentor.userName,
      userCode: mentor.userCode,
      userEmail: mentor.userEmail,
      mentorCode: mentor.mentorCode,
      mentorName: mentor.mentorName,
      mentorType: mentor.mentorType,
      remarks: mentor.remarks,
      dateCreated: mentor.dateCreated,
      isActive: mentor.isActive,
      isDeleted: mentor.isDeleted,
      createdBy: mentor.createdBy,
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const errors = validateForm(formData);
    // console.log("error : ",errors," no. of error",Object.keys(errors).length);
    setFormErrors(errors);
    setCountFormErrors(Object.keys(errors).length);
    // console.log("setFormErrors : ",setFormErrors);

    if (Object.keys(errors).length > 0) {
      setFormErrors(
        Object.keys(errors).reduce((total, key) => {
          total[key] = errors[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/mentors", 
        method: "post", 
        data: {formData: formData, user: authState.user._id}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for Mentor",config);

      fetchData(config).then(() => {
        navigate("/mymentors");
      })
      .catch((error) => {
        console.error("Error saving Mentor:", error);
        setError("Error saving Mentor");
      });
    }
    else {
      const config = { 
        url: `/mentors/${mentorId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for Mentor",config);

      fetchData(config).then(() => {
        navigate("/mymentors");
      })
      .catch((error) => {
        console.error("Error updating Mentor:", error);
        setError("Error updating Mentor");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.mentorCode) {
      errors.mentorCode = "Code is required";
    } else if (formData.mentorCode.length !== 14) {
      errors.mentorCode = "Mentor Code must be 14 characters long";
    } else if (!formData.mentorCode.startsWith("TU")) {
      errors.mentorCode = "Mentor Code must start with 'TU'";
    }
    if (!formData.mentorType) {
      errors.mentorType = "Category is required";
    }
    if (!formData.mentorName) {
      errors.mentorName = "Name is required";
    }
    return errors;
  };

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  return (
    <>
      <div className="min-h-screen bg-black text-white [&_p]:text-white py-2">
        <div>
          <h3 className='text-lg mx-2 border-b border-b-gray-300 text-white'>Learning - Mentor Data Entry</h3>
        </div>
        <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
            {loading ? (
              <Loader />
            ) : (
              <div className='text-sm'>
                <div className='flex justify-center'>
                  <h2 className="ml-2 text-xl text-yellow-200">{mode === "add" ? "Add New Mentor" : "Edit Mentor"}</h2>
                </div>
                <div className="border-container">

                    <div className="mb-2 text-sm">
                      <label htmlFor="mentorType">Mentor Category*</label>
                      <br />
                      <select name="mentorType" id="mentorType" value={formData.mentorType}
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                        <option value="">Select Mentor Category</option>
                        <option value="Teacher">Teacher</option>
                        <option value="Mother">Mother</option>
                        <option value="Father">Father</option>
                        <option value="Grand Parent">Grand Parent</option>
                        <option value="Spouse">Spouse</option>
                        <option value="Sibling">Sibling</option>
                        <option value="Children">Children</option>
                        <option value="Coach">Coach</option>
                        <option value="Senior">Senior</option>
                        <option value="Relative">Relative</option>    
                        <option value="Others">Others</option>    
                      </select>
                      {fieldError("mentorType")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="mentorCode">Mentor Code*:</label>
                      <br />
                      <input
                        type="text"
                        name="mentorCode"
                        id="mentorCode"
                        value={formData.mentorCode}
                        placeholder="Input 14 Character Mentor Code"
                        onChange={handleChange}
                        className="border-inputbox"
                        style={{ 
                          border: '1px solid #ccc', 
                          padding: '8px', 
                          width:'200px', 
                          height: 'auto', 
                          minHeight: '40px' 
                        }}
                      />
                      {fieldError("mentorCode")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="mentorName">Mentor Name:</label>
                      <br />
                      <input
                        type="text"
                        name="mentorName"
                        id="mentorName"
                        value={formData.mentorName}
                        placeholder="Input Name..."
                        onChange={handleChange}
                        className="border-inputbox"
                        style={{ 
                          border: '1px solid #ccc', 
                          padding: '8px', 
                          width:'300px', 
                          height: 'auto', 
                          minHeight: '40px' 
                        }}
                      />
                      {fieldError("mentorName")}
                    </div>
                    <div className="mb-2 text-sm">
                      <p className='text-white'>Remarks:</p>
                      <textarea
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleChange}
                        placeholder="Write here..."
                        maxLength="1000"
                        className='text-black bg-white'
                        style={{ 
                          border: '1px solid #ccc', 
                          padding: '8px', 
                          width:'90%', 
                          height: '150px'
                        }}
                      />
                    </div>
                    <label>
                    <input className='mr-4' type="checkbox" checked={formData.isActive} onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })} />
                      Active?
                    </label>
                </div>

                <div className="border-container flex flex-col justify-center">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-center">
                    <button className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' onClick={handleSubmit}>{mode === "add" ? "Add New" : "Update"}</button>
                    <button className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' onClick={() => navigate("/mymentors")}>Cancel</button>
                    {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>}
                  </div>
                </div>
              </div>
            )}
          </div>
      </div>
    </>
  )
}

export default Mentor